import Moment from 'moment';
import { IExtractProps } from "../services/hooks/useContaPagamento";
import { createListOfMonths } from "./CreateListOfMonths";

function filterItemsWithMaxDatePerMonth(list: IExtractProps[] | undefined): { [key: string]: IExtractProps } {
  const itemsByMonth: { [key: string]: IExtractProps } = {};

  list?.forEach(item => {
    const year = Moment(item.dtMovimento).format("YYYY");
    const month = Number(Moment(item.dtMovimento).format("MM"));

    const monthKey = `${year}-${month}`;

    if (!itemsByMonth[monthKey] || item.dtMovimento > itemsByMonth[monthKey].dtMovimento) {
      itemsByMonth[monthKey] = item;
    }
  });

  return itemsByMonth;//Object.values(itemsByMonth);
}

export function groupDataByMonth(data: IExtractProps[] | undefined, extractInitialDate: Date,
  extractFinalDate: Date) {

  let newListDataMonth: any[] = [];

  const intervalList = createListOfMonths(
    extractInitialDate,
    extractFinalDate
  );
  const lastItemByMonth = filterItemsWithMaxDatePerMonth(data);

  let lastItem: Partial<IExtractProps> = {
    saldoAcumulado: 0,
  };

  intervalList.forEach((interval) => {
    lastItem = lastItemByMonth[`${interval.year}-${interval.month}`] ?? lastItem;

    newListDataMonth.push({
      dtMovimento: `${interval.year}-${interval.month}`,
      saldoAcumulado: lastItem.saldoAcumulado,
    })
  });

  return newListDataMonth;
}
